import {Component, Input, OnInit} from '@angular/core';
import {FormControl, Validators} from "@angular/forms";

@Component({
    selector: 'app-generic-form-field',
    templateUrl: './generic-form-field.component.html',
    styleUrls: ['./generic-form-field.component.scss'],
})
export class GenericFormFieldComponent implements OnInit {

    @Input()
    public fieldKey;

    @Input()
    public fieldData;

    @Input()
    public form;

    constructor() {
    }

    ngOnInit() {
        this.addFormField()
    }

    addFormField() {
        let formControl = new FormControl('', []);
        this.form.addControl(this.fieldKey, formControl);

        if (this.fieldData['required']) {
            this.form.controls[this.fieldKey].setValidators(Validators.required);
        } else {
            this.form.controls[this.fieldKey].clearValidators();
        }

        this.form.controls[this.fieldKey].updateValueAndValidity();
    }

}
